import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  createSchemeIssue,
  fetchAllSchemeIssues,
  updateSchemeIssue,
  fetchOneSchemeIssue,
  deleteSchemeIssue,
  fetchOrdersForRef,
  fetchReconDetails,
  toggleSchemeIssueRecon,
  fetchLastBatchId,
  generateSchemeIssueReport,
} from "services/schIssue";

export const useAllSchemeIssues = (filters = {}, enabled = true) => {
  return useQuery({
    queryKey: ["schemeIssues", filters],
    queryFn: () => fetchAllSchemeIssues(filters),
    enabled,
  });
};

export const useOneSchemeIssue = (id, enabled = true) => {
  return useQuery({
    queryKey: ["schemeIssue", id],
    queryFn: () => fetchOneSchemeIssue(id),
    enabled: Boolean(id) && enabled,
  });
};

export const useCreateSchemeIssue = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => createSchemeIssue(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["schemeIssues"] });
      queryClient.invalidateQueries({ queryKey: ["schemeIssueLastBatchId"] });
    },
  });
};

export const useUpdateSchemeIssue = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => updateSchemeIssue(data, id),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["schemeIssues"] });
      queryClient.invalidateQueries({
        queryKey: ["schemeIssue", variables.id],
      });
    },
  });
};

export const useDeleteSchemeIssue = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => deleteSchemeIssue(id),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({ queryKey: ["schemeIssues"] });
      queryClient.invalidateQueries({ queryKey: ["schemeIssue", id] });
    },
  });
};

export const useOrdersForRef = (params = {}, enabled = true) => {
  return useQuery({
    queryKey: ["schemeIssueOrders", params],
    queryFn: () => fetchOrdersForRef(params),
    enabled: Boolean(params.schmId) && enabled,
  });
};

export const useReconDetails = (params = {}, enabled = true) => {
  return useQuery({
    queryKey: ["schemeReconDetails", params],
    queryFn: () => fetchReconDetails(params),
    enabled: Boolean(params.batch_ids) && enabled,
  });
};

export const useGenerateSchemeIssueReport = () => {
  return useMutation({
    mutationFn: (id) => generateSchemeIssueReport(id),
  });
};

export const useLastBatchId = (type = "B") => {
  return useQuery({
    queryKey: ["schemeIssueLastBatchId", type],
    queryFn: () => fetchLastBatchId(type),
  });
};

export const useToggleSchemeRecon = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => toggleSchemeIssueRecon(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["schemeReconDetails"] });
    },
  });
};
